<template>
  <div>
    <PublicHeaderNew />
    <nuxt />
  </div>
</template>

<script>
import PublicHeaderNew from '~/components/global/PublicHeaderNew'

export default {
  head() {
    const scripts = [
      {
        src: 'https://ws.zoominfo.com/pixel/F7VFa3ZBDQPuOH4kjipA',
        async: true,
        defer: true,
        referrerpolicy: 'unsafe-url',
      }
    ];

    if (process.env.frontendUrl.includes('workera.ai')) {
      scripts.push({ src: 'https://cmp.osano.com/AzqBtjU2KFaQ93EWK/f2679a7f-1db2-481b-9c11-2eb5cb7e3ea9/osano.js' });
    }

    return {
      title: 'Workera',
      meta: [
        {
          hid: 'login',
          name: 'Workera',
          content:
            'Log in to your dashboard, get feedback and find great opportunities',
        },
      ],
      script: scripts,
      link: [
        {
          rel: 'canonical',
          href: 'https://workera.ai' + this.$route.path,
        },
      ],
    }
  },
  components: {
    PublicHeaderNew,
  },
}
</script>
<style>
@import url('https://fonts.googleapis.com/css?family=Assistant:400,700,800&display=swap');
html {
  font-family: 'Assistant' !important;
  font-size: 16px;
  word-spacing: 1px;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;
}

*,
*:before,
*:after {
  box-sizing: border-box;
  margin: 0;
}

.button--green {
  display: inline-block;
  border-radius: 4px;
  border: 1px solid #3b8070;
  color: #3b8070;
  text-decoration: none;
  padding: 10px 30px;
}

.button--green:hover {
  color: #fff;
  background-color: #3b8070;
}

.button--grey {
  display: inline-block;
  border-radius: 4px;
  border: 1px solid #35495e;
  color: #35495e;
  text-decoration: none;
  padding: 10px 30px;
  margin-left: 15px;
}

.button--grey:hover {
  color: #fff;
  background-color: #35495e;
}

#target-container {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
}
</style>
